import React from 'react';
import { takeEvery, put, call } from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';

import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';
import { commandWorkspaceDeploymentsList } from '../actions';

export function* sendRequest(connection, action) {
  const { activityId, cohortId, deploymentId, lockPluginVersionEnabled, supportOnDemandEnabled, scorable, forceUpdateAssessments } = action;

  const projectActivityPublish = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_PROJECT_ACTIVITY_PUBLISH,
    activityId,
    cohortId,
    deploymentId,
    lockPluginVersionEnabled,
    supportOnDemandEnabled,
    scorable,
    forceUpdateAssessments,
  });

  if (projectActivityPublish.type !== constants.RTM_PROJECT_ACTIVITY_PUBLISH_OK) {
    yield put(
      pushToast({
        type: 'simple',
        message: projectActivityPublish.message || <FormattedMessage {...messages.failedProjectActivityPublish} />,
      })
    );
  } else {
    /* Backend doesnt return a deployment DTO, so we update
     * the store by refetching the entire deployment list
     * for the cohort
     */
    yield put(
      pushToast({
        type: 'simple',
        message: 'Class deployment is completed',
      })
    );
    yield put(commandWorkspaceDeploymentsList(cohortId));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_PROJECT_ACTIVITY_PUBLISH, catchErrors, sendRequest, connection);
}
